<template>
  <div>
    <div class="jobsend-steps">
      <Steps />
    </div>
    <div class="jobpool-form">
      <div class="register">
        <div class="inner">
          <div class="main">
            <sui-form autocomplete="off" class="ui form">
              <div class="list">
                <sui-form-field>
                  <label>Candidate Email</label>
                  <div class="email-text">
                    <span class="label">Send to</span
                    ><span class="cdd-email">candidate.email@email.com</span>
                  </div>
                </sui-form-field>
              </div>
            </sui-form>
          </div>
        </div>
      </div>
    </div>
    <div class="job-list">
      <div class="job-item">
        <div class="position">
          <h2>Purchasing Coordinator (Middle Level)</h2>
        </div>
      </div>
    </div>
    <div class="job-info">
      <ul class="list">
        <li class="location checkbox-group">
          <div class="info-group">
            <div class="heading">Location</div>
            <div class="info-text">BTS(Chidlom) , MRT Lines</div>
          </div>
        </li>
        <li class="company checkbox-group">
          <div class="info-group">
            <div class="heading">Salary</div>
            <div class="info-text">35,000 THB - 50,000 THB</div>
          </div>
        </li>
        <li class="company checkbox-group">
          <div class="info-group">
            <div class="heading">Company</div>
            <div class="info-text">Alpha Technology Co.,Ltd</div>
          </div>
        </li>
        <li class="service checkbox-group">
          <div class="info-group">
            <div class="heading">Service / Product</div>
            <div class="info-text">
              Financial Technology, E-Commerce and Digital Marketing Agency
            </div>
          </div>
        </li>
        <li class="business-details checkbox-group">
          <div class="info-group">
            <div class="heading">Business Details</div>
            <div class="info-text">
              We build Apple products to empower everyone. Every device, every
              piece of software, and every service is created with accessibility
              features built in.
            </div>
          </div>
        </li>
        <li class="company-website checkbox-group">
          <div class="info-group">
            <div class="heading">Company Website</div>
            <div class="info-text">
              <a href="/" class="link">https://www.reeracoen.co.th/</a>
            </div>
          </div>
        </li>
        <li class="job-description checkbox-group">
          <div class="info-group">
            <div class="heading">Job Description</div>
            <div class="info-text">
              <ul class="text-list">
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
                  qui, impedit nostrum aspernatur beatae hic nihil animi quaerat
                  totam consequatur Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, cupiditate eos dolor accusamus nobis
                  earum voluptatibus sed, nulla delectus ipsum obcaecati
                  voluptatem qui exercitationem non deserunt rem alias illo
                  distinctio!.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
                  qui, impedit nostrum aspernatur beatae hic nihil animi quaerat
                  totam consequatur.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
                  qui, impedit nostrum aspernatur beatae hic nihil animi quaerat
                  totam consequatur.
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="requirement checkbox-group">
          <div class="info-group">
            <div class="heading">Requirement</div>
            <div class="info-text">
              <ul class="text-list">
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
                  qui, impedit nostrum aspernatur beatae hic nihil animi quaerat
                  totam consequatur Lorem ipsum dolor sit amet consectetur
                  adipisicing elit. Quo, cupiditate eos dolor accusamus nobis
                  earum voluptatibus sed, nulla delectus ipsum obcaecati
                  voluptatem qui exercitationem non deserunt rem alias illo
                  distinctio!.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
                  qui, impedit nostrum aspernatur beatae hic nihil animi quaerat
                  totam consequatur.
                </li>
                <li>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
                  qui, impedit nostrum aspernatur beatae hic nihil animi quaerat
                  totam consequatur.
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="benefit checkbox-group">
          <div class="info-group">
            <div class="heading">Benefit</div>
            <div class="info-text">
              <ul class="text-list">
                <li>Provident Fund</li>
                <li>Annual Health Checkup</li>
              </ul>
            </div>
          </div>
        </li>
        <li class="working-hour checkbox-group">
          <div class="info-group">
            <div class="heading">Working Houre</div>
            <div class="info-text">8:00 - 17:30</div>
          </div>
        </li>
        <li class="holiday checkbox-group">
          <div class="info-group">
            <div class="heading">Holiday</div>
            <div class="info-text">
              <ul class="text-list">
                <li>Weekend</li>
                <li>Holiday</li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="button-row">
      <router-link to="/dashboard/job-pool/job-send">
        <button class="btn btn-outline" type="submit">Edit</button>
      </router-link>
      <router-link to="/dashboard/job-pool/job-send/completed">
        <button class="btn btn-blue" type="submit">Send</button>
      </router-link>
    </div>
  </div>
</template>
<script>
import Steps from "../../views/components/Steps.vue";
export default {
  name: "JobSendForm",
  components: {
    Steps,
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/stylesheets/application";
@import "@/assets/stylesheets/register";
.jobsend-steps {
  padding-bottom: 5rem;
  /deep/ .steps {
    .line.line-1 {
      border-top: 1px solid $blue-primary !important;
    }
  }
}
.jobpool-form {
  margin-bottom: 2rem;
  .register {
    .ui.form {
      margin: 0;
    }
  }
  .email-text {
    .label {
      color: $gray;
      margin-right: 1rem;
    }
    .cdd-email {
      color: $black;
      font-size: 1em;
      font-weight: 500;
      position: relative;
      &::after {
        position: absolute;
        font-family: "Font Awesome 5 Free";
        content: "\f00c";
        font-weight: 900;
        color: #2ecc71;
        padding-left: 10px;
      }
    }
  }
}
.job-list {
  .job-item {
    align-items: stretch;
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    padding: 0;
    width: 100%;
    .position {
      margin-bottom: 1rem;
      h2 {
        font-size: 1.25em;
      }
    }
  }
}
.job-info {
  .list {
    .checkbox-group {
      display: flex;
    }
    li {
      margin-bottom: 1.5rem;
      .heading {
        color: $black;
        font-size: 1em;
        font-weight: 700;
        margin-bottom: 0.5rem;
      }
      .info-text {
        color: $black;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
          Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
          "Segoe UI Symbol";
        font-size: 14px;
        line-height: 1.5rem;

        .text-list {
          list-style-type: disc;
          padding-left: 1.2rem;
          li {
            line-height: 1.5rem;
            margin-bottom: 5px;
          }
        }
      }
      .link {
        color: $black;
        text-decoration: underline;
        &:hover,
        &:focus {
          color: $black;
        }
      }
    }
  }
}
.button-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
  .btn {
    margin: 0 0.5rem;
    width: 120px;
  }
}

@media only screen and (max-width: 991px) {
  .job-list {
    .job-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 1rem;
      padding: 0;
    }
  }
  .job-info {
    .list {
      .checkbox-group {
        display: flex;
        .checkbox {
          margin-right: 10px;
        }
      }
      li {
        margin-bottom: 1.5rem;
        .heading {
          font-size: 14px;
        }
        .info-text {
          font-size: 14px;
        }
      }
    }
  }
  .jobpool-form {
    h2 {
      font-size: 1.15em;
    }
    p {
      font-size: 14px;
    }
    .register {
      .ui.form {
        width: 100%;
      }
    }
  }
}
</style>
